import axios from 'axios';

const paymentUrl = `${process.env.REACT_APP_BASE_URL}/services/userprofile/api/patients/backoffice/payment-method`;
const patientsBackofficeUrl = `${process.env.REACT_APP_BASE_URL}/services/userprofile/api/patients/backoffice`;

export const editPayment = async (token, id, data, displayError = () => {}) => {
    return await axios.put(`${paymentUrl}/${id}`, data,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        return response.data;
    })
    .catch((error) => {
        if(token) displayError("editPayment error: " + error.message)
    });
}
export const getPaymentMethod = async (token, userLogin,product) => {
  return await axios
    .get(`${patientsBackofficeUrl}/get-payment-method/${userLogin}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // if (token) displayError("getPatients error: " + error.message);
    });
};